(function () {
  const PREFIX = "http://www.";

  function initUrlAutofill(root = document) {
    const inputs = root.querySelectorAll('input[data-type="url"].material_outlined-input');

    inputs.forEach((input) => {
      if (input.dataset.urlAutofillBound === "1") return;
      input.dataset.urlAutofillBound = "1";

      input.addEventListener("focus", () => {
        if (!input.value) {
          input.value = PREFIX;

          const label = document.querySelector(`label[for="${input.id}"]`);
          if (label) label.classList.add("gfb__label__filled");

          setTimeout(() => {
            input.setSelectionRange(input.value.length, input.value.length);
          }, 0);
        }
      });

      input.addEventListener("blur", () => {
        if (input.value.trim() === PREFIX) {
          input.value = "";

          const label = document.querySelector(`label[for="${input.id}"]`);
          if (label) label.classList.remove("gfb__label__filled");
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initUrlAutofill();

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches?.('input[data-type="url"].material_outlined-input')) {
            initUrlAutofill(node.parentElement || document);
          } else if (node.querySelector?.('input[data-type="url"].material_outlined-input')) {
            initUrlAutofill(node);
          }
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
